import { createStyles, Theme } from '@material-ui/core/styles';

import { colors, colours } from '@shared/theme/colours';

const footerHeight = 68;
const headerHeight = 68;

export const styles = ({ spacing, breakpoints }: Theme) =>
  createStyles({
    root: {
      width: 650,
      maxWidth: '100%',
      height: '100%',
    },
    assigneeDraggableList: {
      maxWidth: 480,
    },
    header: {
      padding: spacing(4),
      height: headerHeight,
      flex: '0 0 auto',
    },
    headerCloseBtn: {
      border: 'none',
    },
    headerText: {
      fontSize: 22,
      fontWeight: 500,
      color: colours.neutral[900],
      lineHeight: '30px',
      width: '100%',
      margin: spacing(0, 2),
    },
    content: {
      overflowY: 'auto',
      height: `calc(100vh - ${footerHeight}px)`,
    },
    contentItems: {
      padding: spacing(6, 6, 18.75),
      gap: 24,
    },
    dateContainer: {
      gap: 8,
      width: '100%',
    },
    datePicker: {
      height: '40px !important',
      width: '100%',

      '& .MuiOutlinedInput-inputAdornedStart': {
        fontSize: 14,
      },

      '& .MuiOutlinedInput-adornedStart': {
        width: '100%',
        height: '40px !important',
      },
      [breakpoints.down(768)]: {
        '& .MuiOutlinedInput-adornedStart': {
          width: '100%',
        },
      },
    },
    label: {
      display: 'block',
      marginBottom: spacing(2),
      fontWeight: 500,
    },
    notes: {
      minHeight: 132,
      display: 'flex',
      alignItems: 'flex-start',
      paddingTop: spacing(2.5),
      '& textarea': {
        resize: 'none',
      },
    },
    timeSelector: {
      height: '40px !important',
      width: '100%',
      background: colours.solid.white,
      '& .MuiOutlinedInput-root': {
        height: '40px !important',
      },
    },
    fullRowElement: {
      width: '100%',
    },
    rowElement: {
      flex: 1,
    },
    assigneeSelect: {
      width: '100%',
    },
    assigneeErrorText: {
      color: colors.red.darkish,
      fontSize: 13,
    },
    block: {
      padding: spacing(6),
      borderRadius: 8,
      backgroundColor: colours.neutral[50],
      width: '100%',
    },
    detailsContainer: {
      gap: 24,
    },
    dateBlock: {
      gap: 24,
    },
    drawerOverlay: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%,-50%)',
    },
    blockTitle: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: '28px',
      display: 'inline-block',
      marginBottom: spacing(4),
      textTransform: 'capitalize',
    },
    blockSubtitle: {
      fontSize: 14,
      fontWeight: 500,
      color: colours.neutral[500],
      display: 'block',
    },
    blockInfo: {
      gap: 24,
    },
    blockText: {
      fontSize: 14,
      fontWeight: 500,
    },
    linkContainer: {
      gap: 8,
    },
    detailItemLast: {
      borderBottom: `1px solid ${colours.neutral[100]}`,
      paddingBottom: spacing(7),
      marginBottom: spacing(4),
    },
    notesText: {
      wordBreak: 'break-word',
      fontSize: 14,
      color: colours.neutral[900],
      fontWeight: 400,
      lineHeight: '20px',
    },
    pickedDisabled: {
      '& .MuiOutlinedInput-adornedStart': {
        backgroundColor: colours.neutral[100],
      },
    },
    selectAdornment: {},
    selectAdornmentIcon: {
      fontSize: 15,
      marginTop: spacing(1),
      color: colours.neutral[900],
    },
    continueButton: {
      padding: spacing(2.5, 4),
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      height: footerHeight,
      gap: 12,
      position: 'absolute',
      width: '100%',
      bottom: 0,
      zIndex: 2,
      borderTop: `1px solid ${colours.neutral[200]}`,
      padding: spacing(0, 6),
      backgroundColor: colours.solid.white,
    },
  });
